import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router'
// import store from '../store/index'
import { i18n } from '../plugins/i18n'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  let language = to.params.lang
  if (!language) {
    language = 'th'
  }

  i18n.locale = language
  next()

  // if (store.state.language.language !== i18n.locale) {
  //   i18n.locale = store.state.language.language
  //   next()
  // } else if (!store.state.language.language) {
  //   store.dispatch('language/setLanguage', navigator.languages)
  //     .then(() => {
  //       i18n.locale = store.state.language.language
  //       next()
  //     })
  // } else {
  //   next()
  // }
})

export default router
